<template>
    <base-dialog :value="dialog" :title="$t('common.more_information')" :width="560" @input="onDialogInput"
        @close="hide">
        <div class="freemium-body" v-html="$t('payment.freemium_end_body')" />
        <template #footer>
            <v-btn v-if="paymentsEnabled" class="footer-btn" depressed block @click="goToChange">
                {{ changeLabelButton }}
            </v-btn>
            <div v-else class="freemium-web-note">
                {{ $t('payment.change_plan_from_desktop') }}
            </div>
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "FreemiumEndDialog",
    components: { BaseDialog },
    data() {
        return {
            dialog: false,
        }
    },
    computed: {
        changePaymentRoute(vm = this) {
            return `${vm.accountType}.payment.edit`
        },
        changePlanRoute(vm = this) {
            return `${vm.accountType}.select-plan`
        },
        changeLabelButton(vm = this) {
            if (vm.account?.stripeAccount?.paymentMethod) return vm.$t('common.change_plan')
            return vm.$t('common.change_card')
        }
    },
    methods: {
        show() {
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
        goToChange() {
            const vm = this;
            if (vm.account?.stripeAccount?.paymentMethod) {
                vm.hide()
                return vm.pushRoute({ name: vm.changePlanRoute })
            }
            vm.hide()
            vm.pushRoute({ name: vm.changePaymentRoute })
        }
    },
}
</script>

<style scoped>
.freemium-body {
    font-size: var(--fs-body);
    line-height: 1.55;
    color: var(--v-txtSecondary-base);
    text-align: center;
}

.freemium-body >>> .bolder {
    color: var(--v-txtPrimary-base);
    font-weight: 700;
}

.freemium-web-note {
    padding: 18px 20px;
    background: var(--v-surface2-base);
    font-size: var(--fs-body);
    line-height: 1.5;
    color: var(--v-txtSecondary-base);
    text-align: center;
}

.footer-btn.v-btn {
    height: 52px !important;
    border-radius: 0 !important;
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    box-shadow: none !important;
    background: var(--v-primary-base) !important;
    color: #0C0E12 !important;
}
</style>
